function truncator(input) {
	if (input.length < 12) {
		return input
	}
	return input.slice(0, 6) + '…' + input.slice(-6)
}

export default truncator
